import React, { useState } from "react";
import Button from "../../form/Button";
import Input from "../../form/Input";
import AdvancedSettingsAddon from "./AdvancedSettingsAddon";
import DatePicker from "../../form/DatePicker";
import TimePicker from "../../form/timePicker/TimePicker";

const VarientForm = ({
  handleChange = () => {},
  formValidate = () => {},
  values,
  errors,
}) => {
  const [showForm, setShowForm] = useState(false);
  return (
    <>
      {!showForm ? (
        <Button buttonIcon={"fa-light fa-plus"} buttonLabel={"Add Variation"} />
      ) : (
        <div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="relative w-full">
              <Input
                labelClasses={"!text-lg !text-deep-purple !mb-2"}
                inputClasses={
                  "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                }
                label={"Variation name"}
                onChange={handleChange}
                value={values?.name}
                inputName={"name"}
                {...formValidate(errors, "name")}
              />
            </div>
            <div className="relative w-full">
              <Input
                label={"Available quantity"}
                labelClasses={"!text-lg !text-deep-purple !mb-2"}
                inputClasses={
                  "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                }
                inputName={"quantity"}
                inputType="number"
                onKeyDown={(e) => {
                  const blockedKeys = ["+", "-", "e", "E", " ", "."];
                  if (
                    blockedKeys.includes(e.key) ||
                    (e.key === "=" && e.shiftKey)
                  ) {
                    e.preventDefault();
                    return;
                  }
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    e.target.value = value;
                    handleChange(e);
                  }
                }}
                value={values?.quantity}
                {...formValidate(errors, "quantity")}
              />
            </div>
            <div className="relative w-full">
              <Input
                label={"Price"}
                labelClasses={"!text-lg !text-deep-purple !mb-2"}
                inputClasses={
                  "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple !pl-10"
                }
                inputPrefix
                iconClasses={"fa-regular fa-dollar-sign"}
                inputName={"price"}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    e.target.value = value;
                    handleChange(e);
                  }
                }}
                value={values?.price}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-5">
            <div className="relative">
              <DatePicker
                label={"Sales start"}
                labelClasses={"!text-lg !text-deep-purple !mb-2"}
                placeholder={"Select Date"}
                inputClassName={
                  "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                }
                onChange={(val) => {
                  handleChange({
                    target: { name: "salesStartDate", value: val?.startDate },
                  });
                }}
                value={{
                  startDate: values?.salesStartDate,
                  endDate: values?.salesStartDate,
                }}
                {...formValidate(errors, "salesStartDate")}
              />
            </div>
            <div className="relative">
              <TimePicker
                label={"Start Time"}
                labelClasses={"!text-lg !text-deep-purple !mb-2"}
                inputClassName={
                  "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                }
                onChange={(val) => {
                  handleChange({
                    target: { name: "salesStartTime", value: val },
                  });
                }}
                value={values?.salesStartTime}
                {...formValidate(errors, "salesStartTime")}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-5">
            <div className="relative">
              <DatePicker
                label={"Sales end"}
                labelClasses={"!text-lg !text-deep-purple !mb-2"}
                placeholder={"Select Date"}
                inputClassName={
                  "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                }
                onChange={(val) => {
                  handleChange({
                    target: { name: "salesEndDate", value: val?.startDate },
                  });
                }}
                value={{
                  startDate: values?.salesEndDate,
                  endDate: values?.salesEndDate,
                }}
                {...formValidate(errors, "salesEndDate")}
              />
            </div>
            <div className="relative">
              <TimePicker
                label={"End Time"}
                labelClasses={"!text-lg !text-deep-purple !mb-2"}
                inputClassName={
                  "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
                }
                onChange={(val) => {
                  handleChange({
                    target: { name: "salesEndTime", value: val },
                  });
                }}
                value={values?.salesEndTime}
                {...formValidate(errors, "salesEndTime")}
              />
            </div>
          </div>
          <AdvancedSettingsAddon />
        </div>
      )}
    </>
  );
};

export default VarientForm;
